import { EBillingStatus, IInvoiceReferenceBasic } from '../billing';
import { UUID } from '../common';
import { IDigitizedDeliveryNote } from '../documentation';
import { EFastPaymentForCarrierStatus } from '../fast-payment-carrier';
import { EFreightLoadingType, EFreightTransportGoodsType, IFreightDriver, IFreightVehicle } from '../freight-common';
import { EStopStatus, EStopType, IStopBasicForCarrier, IStopDetailedForCarrier } from '../stop';
import { EVehicleType } from '../vehicle';
import { EFreightForCarrierStatus } from './freight-carrier.enum';

// comes from FreightBasicForCarrierResponse
export interface IFreightBasicForCarrier {
  id: UUID;
  status: EFreightForCarrierStatus;
  reference: string;
  numberOfStops: number; // calculated property

  stopsBasic: IStopBasicForCarrier[];
  vehicles: IFreightVehicle[];
  drivers: IFreightDriver[];
  invoiceList: IInvoiceReferenceBasic[];

  scheduledKm?: number;
  price?: number;
  billingStatus?: EBillingStatus;
  fastPaymentForCarrierStatus?: EFastPaymentForCarrierStatus;
  hasPendingDoc?: boolean;
  deliveryNoteInPaperRequired?: boolean;
  deliveryNoteInPaperReceived?: boolean;

  nextStopId?: UUID; // calculated property
  nextStopType?: EStopType; // calculated property
  nextStopStatus?: EStopStatus; // calculated property
}

// comes from FreightDetailForCarrier
export interface IFreightDetailedForCarrier extends Omit<IFreightBasicForCarrier, 'stopsBasic'> {
  stopsDetailed: IStopDetailedForCarrier[];

  title: string; // calculated property

  transportGoodsType: EFreightTransportGoodsType;
  vehicleTypes: EVehicleType[];
  loadingTypes: EFreightLoadingType[];

  digitizedDeliveryNotes: IDigitizedDeliveryNote[]; // calculated array

  instructions: string;
  observations: string; // old carrierObservations

  loadedKm?: number;
  emptyKm?: number;
  detourKm?: number;
  loadedPerKmPrice?: number;
  emptyPerKmPrice?: number;
  detourPerKmPrice?: number;
  payInAdvanceRequestedAt?: Date;
  payInAdvanceApprovedAt?: Date;
  payInAdvanceRejectedAt?: Date;
  payInAdvanceRejectedReason?: string;
  costDiscount?: number;

  waste?: boolean; // calculated property

  // TODO recover these?
  // deliveryNoteInPaperSentAt?: Date;
  // deliveryNoteInPaperReceivedAt?: Date;
  // temperatureMin?: number;
  // temperatureMax?: number;
  // temperatureUnit?: string;
}

// TODO with the refactor to signals in components and services, this can likely be removed
export function getEmptyFreightBasicForCarrier(): IFreightBasicForCarrier {
  return {
    id: '',
    status: EFreightForCarrierStatus.DEFAULT,
    reference: '',
    stopsBasic: [],
    drivers: [],
    vehicles: [],
    numberOfStops: 0,
    invoiceList: [],
  } as IFreightBasicForCarrier;
}

// TODO with the refactor to signals in components and services, this can likely be removed
// TODO add default stops?
export function getEmptyFreightDetailedForCarrier(): IFreightDetailedForCarrier {
  return {
    stopsDetailed: [],
    transportGoodsType: EFreightTransportGoodsType.NORMAL,
    vehicleTypes: [],
    loadingTypes: [],
    instructions: '',
    observations: '',
    scheduledKm: 0,
    title: '',
    id: '',
    status: EFreightForCarrierStatus.DEFAULT,
    reference: '',
    vehicles: [],
    drivers: [],
    numberOfStops: 0,
    invoiceList: [],
    digitizedDeliveryNotes: [],
  } as IFreightDetailedForCarrier;
}
